
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/invest",
      function () {
        return require("private-next-pages/invest.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/invest"])
      });
    }
  